import { __assign } from "tslib";
import { StyleSheet } from "react-native";
import styles from "../styles/styles";
export default StyleSheet.create({
  footerContainer: {
    marginTop: 5,
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 10
  },
  footerText: {
    fontSize: 14,
    color: "#aaa"
  },
  chatContainer: __assign({
    borderRadius: 15,
    overflow: "hidden"
  }, styles.shadowStyles)
});